import styled from 'styled-components';
import {dFlex, flexWrap, alignStart, justifyCenter, justifyStart} from '../../../../../globalVariables/GlobalFlex';

export const wrap = styled.div<{$isEmpty: boolean}>`
    ${dFlex}
    ${flexWrap}
    ${alignStart}
    ${({$isEmpty}) => ($isEmpty ? justifyCenter : justifyStart)}
    gap: var(--space-sm);
    width: 100%;
`;
